class CollectionAgeVerifier extends HTMLElement {
  constructor() {
    super();

    this.collectionHandle = this.dataset.collectionHandle;
    this.storageKey = `age-verified-${this.collectionHandle}`;

    this.classes = {
      bodyClass: 'promo-popup--open',
      activeClass: 'is-active',
      closingClass: 'is-closing',
      showImage: 'show-image',
      restrictedClass: 'collection-age-restricted'
    };

    this.popup = this.querySelector('.promo-popup');
    this.yesButton = this.querySelector('[data-age-verify="yes"]');
    this.noButton = this.querySelector('[data-age-verify="no"]');

    this.init();
  }

  connectedCallback() {
    if (this.yesButton) {
      this.yesButton.addEventListener('click', this.handleYes.bind(this));
    }
    if (this.noButton) {
      this.noButton.addEventListener('click', this.handleNo.bind(this));
    }
  }

  init() {
    const verification = sessionStorage.getItem(this.storageKey);
    
    if (verification === 'yes') {
      this.allowAccess();
    } else if (verification === 'no') {
      this.restrictAccess();
    } else {
      this.showVerificationPopup();
    }
  }

  showVerificationPopup() {
    // Show the custom element
    this.classList.add('show-overlay');
    
    // Activate the popup
    this.popup.classList.add(this.classes.activeClass);
    setTimeout(() => {
      this.popup.classList.add(this.classes.showImage);
    }, 100);

    // Lock body scroll
    if (this.popup.dataset.position === 'center') {
      if (typeof setScrollbarWidth === 'function') {
        setScrollbarWidth();
      }
      document.body.classList.add(this.classes.bodyClass);
      document.body.style.overflow = 'hidden';
    }
  }

  handleYes() {
    sessionStorage.setItem(this.storageKey, 'yes');
    this.closePopup();
    this.allowAccess();
  }

  handleNo() {
    sessionStorage.setItem(this.storageKey, 'no');
    this.closePopup();
    this.restrictAccess();
  }

  closePopup() {
    this.popup.classList.add(this.classes.closingClass);

    setTimeout(() => {
      this.popup.classList.remove(this.classes.activeClass);
      this.popup.classList.remove(this.classes.closingClass);
      this.popup.classList.remove(this.classes.showImage);
      this.classList.remove('show-overlay');

      if (this.popup.dataset.position === 'center') {
        document.body.classList.remove(this.classes.bodyClass);
        document.body.style.overflow = '';
      }
    }, 500);
  }

  allowAccess() {
    const productGridContainer = document.querySelector('.section--padding');
    if (productGridContainer) {
      productGridContainer.classList.remove(this.classes.restrictedClass);
    }
  }

  restrictAccess() {
    const productGridContainer = document.querySelector('.section--padding');
    if (productGridContainer) {
      productGridContainer.classList.add(this.classes.restrictedClass);
    }

    const productGrid = document.getElementById('product-grid');
    if (productGrid && productGrid.parentElement) {
      const existingMessage = productGrid.parentElement.querySelector('.collection-age-restricted-message');
      if (!existingMessage) {
        const message = document.createElement('div');
        message.className = 'collection-age-restricted-message';
        message.innerHTML = `
          <h2>Access Restricted</h2>
          <p>You must be 18 or older to view these products.</p>
          <p>You can still Checkout with the current items in your cart.</p>
        `;
        productGrid.parentElement.insertBefore(message, productGrid);
      }
    }
  }
}

customElements.define('collection-age-verifier', CollectionAgeVerifier);

